import { useQuery } from "@tanstack/react-query";
import { useStoreId } from "../../../core/auth/useLoggedInUser";
import { fetchShoppingToolsSettings } from "../ShoppingToolsAPI";
import { INTERVAL } from "../../../constants/clientTime";

export const useFetchShoppingtoolsSettings = () => {
  const storeId = useStoreId();

  return useQuery({
    queryKey: ["shopping-tools-settings", storeId],
    queryFn: () => {
      return fetchShoppingToolsSettings(storeId);
    },
    staleTime: INTERVAL.MINUTE * 1,
  });
};
